<section class="home_banner">
    <div class="swiper-container" [swiper]="bannerConfig">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="banner_img">
            <img src="../../../../../assets/images/banner/banner3.webp" class="banner_img" alt="img">
          </div>
          <div class="wrapper banner_container">
            <div class="banner_full">
              <div class="banner_content">
                <h1 class="wow slideInLeft" data-wow-duration="0.6s" data-wow-delay="0.8s">Making <span>NARMETTA </span><br>a Multi-produce powerhouse</h1>
              </div>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="banner_img">
            <img src="../../../../../assets/images/banner/banner4.webp" class="banner_img" alt="img">
          </div>
          <div class="wrapper banner_container">
            <div class="banner_full">
              <div class="banner_content">
                <h1 class="wow slideInLeft" data-wow-duration="0.6s" data-wow-delay="0.8s">Nurturing the minds of the <span>FUTURE</span></h1>
              </div>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="banner_img">
            <img src="../../../../../assets/images/banner/banner.png" class="banner_img" alt="img">
          </div>
          <div class="wrapper banner_container">
            <div class="banner_full">
              <div class="banner_content">
                <h1 class="wow slideInLeft" data-wow-duration="0.6s" data-wow-delay="0.8s">Building a <span>Healthier</span>community</h1>
              </div>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="banner_img">
            <img src="../../../../../assets/images/banner/banner2.webp" class="banner_img" alt="img">
          </div>
          <div class="wrapper banner_container">
            <div class="banner_full">
              <div class="banner_content">
                <h1 class="wow slideInLeft" data-wow-duration="0.6s" data-wow-delay="0.8s">Watching out for <span>SAFTEY</span>for all</h1>
              </div>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
      
      </div>
      <!-- <span class="navigations">
        <span class="controls">
          <i class="swiper-button-prev first-swiper-button-prev"> </i>
          <i class="swiper-button-next first-swiper-button-next"></i>
        </span>
      </span> -->
  
    </div>
  </section>